import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useCombineRefs } from "../hooks/useCombineRefs";
import * as Styled from "./PortalRoot.styled";
import { PortalRootContext } from "./PortalRootContext";
export const PortalRoot = forwardRef((props, ref) => {
    const rootRef = useRef(null);
    const [rootElement, setRootElement] = useState(rootRef.current);
    useEffect(() => {
        setRootElement(rootRef.current);
    }, []);
    return (_jsx(PortalRootContext.Provider, { value: rootElement, children: _jsx(Styled.PortalRoot, { ref: useCombineRefs(rootRef, ref), "data-testid": "PortalRoot", ...props }) }));
});
PortalRoot.displayName = "PortalRoot";
